module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"watchdogDashboard.title":"Watchdog"}}')
  delete Component.options._Ctor
}
